module.exports = "<div class=\"ship-popup-wrapper\">\n  <lfwms-result-data-table [searchService]=\"lookupSearchService\">\n  </lfwms-result-data-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.html
// module id = ../../../../../src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.html
// module chunks = main